import { HttpClient } from '../../../shared/api/httpClient';
import { API_ENDPOINT } from '../../../shared/constanst/constants';
import { AxiosPromise } from 'axios';

const API_SLUG = 'Paises';

export interface Pais {
  codPais: string;
  pais: string;
}

export class PaisesAdapter {
	private cliente: HttpClient;

	constructor() {
		this.cliente = new HttpClient(API_ENDPOINT, API_SLUG);
	}

	ListarPaises(): AxiosPromise<Pais[]> {
		return this.cliente.get(`/ListarPaises`);
	}

	ListarPaisesExpatriadosHistorico(): AxiosPromise<Pais[]> {
		return this.cliente.get(`/ListarPaisesHistoricoExpatriados`);
	}
}